import { Box, Typography } from '@mui/material';

const counterCardSx = {
  info: {
    backgroundColor: '#E2F1EA',
    border: '1px solid #D2E4DA',
    '& .MuiTypography-root': {
      color: '#2E4537 !important',
    },
  },
  expiring: {
    backgroundColor: '#EECBBC',
    border: '1px solid #6E260D',
    '& .MuiTypography-root': {
      color: '#6E260D !important',
    },
  },
  expired: {
    backgroundColor: '#EA9997',
    border: '1px solid #7C2925',
    '& .MuiTypography-root': {
      color: '#7C2925 !important',
    },
  },
};

export const StatusCounterCard = (props: {
  variant: keyof typeof counterCardSx;
  count: number;
  caption: string;
}) => (
  <Box className="statusCounter-card" sx={counterCardSx[props.variant]}>
    <Typography variant="h4" gutterBottom>
      {props.count}
    </Typography>
    <Typography variant="caption" gutterBottom>
      {props.caption}
    </Typography>
  </Box>
);
